import React from "react";
import { useNavigate } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* comp imports */
import BackArrow from "../components/BackArrow";
import SectionHeading from "../components/SectionHeading";
import PageTransition from "../components/PageTransition";

const NotFound = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };
  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper under-dev-page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/" />
        <SectionHeading
          sectiontitle="Page"
          sectiontitle2="Not"
          textAlign="text-center"
        />
        <SectionHeading sectiontitle="Found" textAlign="text-center" />
        <SectionHeading
          sectiontitle="Unknown"
          sectiontitle2="URL(Link)"
          textAlign="text-center"
        />
        <div className="joker-wrapper"></div>
      </div>
    </>
  );
};

export default NotFound;
